import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {Typography} from "@mui/material"

interface StyledTextWrapperProps {
    capitalizeFirstLetter?: boolean
}

export const StyledProductTitle = styled("div")`
    padding-inline-start: 1rem;
    grid-area: title;
    overflow: hidden;
    @media (max-width: ${breakpoints.values.md - 1}px) {
        padding: 0 1rem 0 1rem;
        max-width: 96vw;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        // because horrizontal filters are positioned with sticky we need to set a height
        // otherwise overflow hidden will hide the content, only sticky on lg breakpoints
        min-height: 3.25rem;
        padding-inline-start: 0;
    }

    #plp-results-count-cotton-text {
        font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
        color: ${props => props.theme.colours.text.search};
        font-size: ${({theme: {colours}}) => colours.typography.h1.fontSize};
        letter-spacing: 0.12px;
        line-height: 1.5;
        font-weight: 500;

        @media (min-width: ${breakpoints.values.lg}px) {
            display: inline-flex;
            margin-top: 0.375rem;
        }
    }

    // apply this styling below for ESI SEO heading h1 element
    h1 {
        font-family: ${({theme: {colours}}) => `${colours.font.primary.medium.family}, ${colours.font.default}`};
        font-weight: ${({theme: {colours}}) => colours.font.primary.medium.weight};
        color: ${({theme: {colours}}) => colours.text.default};
        font-size: ${({theme: {colours}}) => colours.typography.h1.fontSize};
        letter-spacing: 0.12px;
        line-height: 1.5;
        margin: 0;
        vertical-align: bottom;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (min-width: ${breakpoints.values.lg}px) {
            margin: 0.375rem 0 0 0;
        }
    }

    .esi-header-wrapper {
        display: flex;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: ${({theme: {colours}}) => colours.typography.h1.textTransform};
    }

    // product count after the ESId heading
    .esi-count {
        font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
        color: ${props => props.theme.colours.text.search};
        vertical-align: bottom;
        line-height: 1.5;
        letter-spacing: 0.12px;
        font-size: ${({theme: {colours}}) => colours.typography.h1.fontSize};
        font-weight: ${({theme: {colours}}) => colours.font.primary.medium.weight};
        @media (min-width: ${breakpoints.values.lg as number}px) {
            margin: 0.375rem 0 0 0;
        }
        // esi attempt/except doesn't work properly in dev
        // if the esi:include fails, it will leave the count on its own
        &:only-child {
            display: none;
        }
    }
`

export const StyledCount = styled("span")`
    font-family: ${({theme}) => `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme: {colours}}) => colours.font.primary.medium.weight};
    color: ${props => props.theme.colours.text.search};
    font-size: ${({theme: {colours}}) => colours.typography.h1.fontSize};
    letter-spacing: 0.12px;
    line-height: 1.5;
    @media (min-width: ${breakpoints.values.lg as number}px) {
        margin: 0.375rem 0 0 0;
    }
`

export const StyledNoResultsFound = styled("span", {shouldForwardProp: prop => !String(prop).startsWith("$")})<{
    $enableCentreTitle: boolean
}>`
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    color: ${({theme: {colours}}) => colours.text.default};
    font-weight: ${({theme: {colours}}) => colours.font.primary.medium.weight};
    display: block;
    font-size: 0.875rem;
    line-height: 1.5;
    letter-spacing: 0.0075rem;
    text-align: ${props => (props.$enableCentreTitle ? "center" : "start")};
`

export const StyledTextWrapper = styled("span")<StyledTextWrapperProps>`
    ${({capitalizeFirstLetter}) =>
        capitalizeFirstLetter &&
        `
        &:first-letter {
            text-transform: capitalize;
        }
        `}}
    @media (min-width: ${breakpoints.values.sm}px) {
        max-width: 25rem;
    }
`

export const StyledSecondaryText = styled(Typography, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$enableCentreTitle: boolean}>`
    font-size: 0.875rem;
    line-height: 1.25rem;
    letter-spacing: 0.0075rem;
    text-align: ${props => (props.$enableCentreTitle ? "center" : "start")};
`

export const StyledCapitalizedText = styled("span")`
    text-transform: capitalize;
`

export const StyledShowingResultsForText = styled("span")`
    @media (max-width: ${breakpoints.values.sm}px) {
        display: none;
    }
`

export const CategoryWrapper = styled("div")`
    overflow: hidden;
`
export const CategoryHeading = styled("div")`
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
`
